import assign from 'object-assign';

const DEFAULT_STATE = {
  isMapLoading: false
};


export const setInitData = (dispatch, action) => {
  dispatch({
    type: 'INIT_GM_DATA',
    data: {
      action
    }
  });
};


export default function reducer(state = DEFAULT_STATE, action = {}) {
  switch (action.type) {
    case 'INIT_GM_DATA': {
      return assign({}, state, action.data);
    }
    default:
      return state;
  }
}
